// extracted by mini-css-extract-plugin
export default {"page-heading-container":"PageHeading_page-heading-container__5AkVJ","page-heading":"PageHeading_page-heading__q0tLd"};